import { f as _defineProperty, _ as _objectSpread2 } from './slicedToArray-1793c995.esm.js';
import _mapObjIndexed from 'ramda/src/mapObjIndexed';

/* eslint-disable no-nested-ternary */
var focusSelector = ':focus';
var focusVisibleSelector = ':focus-visible';
var focusVisibleInvertSelector = ':focus:not(:focus-visible)';
var invert = function invert(styles) {
  return _mapObjIndexed(function () {
    return 'none';
  }, styles);
};

/**
 * Override browser default focus styles with provided styles.
 *
 * Currently supports `:focus-visible` via the second parameter. Because not
 * all browsers (looking at you Safari) support `:focus-visible`, we need to
 * first apply any provides styles to `:focus` and then remove them in browsers
 * that support `:focus-visible`. Passing a `true` to `visibleOnly` will simply
 * try to "invert" the provided focus styles by setting each property to
 * `none`. For finer grained control, pass a `CSSObject` as the `visibleOnly`
 * parameter to provide the default unfocused state that will be applied to
 * browsers that do support `:focus-visible`.
 *
 * @example
 * Apply custom styles to `:focus`
 * ```ts
 * resetFocus({ border: '1px solid red' })
 * ```
 *
 * @example
 * Apply custom styles to `:focus-visible` (this will only work if the default state
 * does not include a `border`, see next example for how to handle that case)
 * ```ts
 * resetFocus({ border: '1px solid red' }, true);
 * ```
 *
 * @example
 * Apply custom styles to `:focus-visible` with unfocused defaults
 * ```ts
 * resetFocus({ border: '1px solid red' }, { border: '1px solid gray' }});
 * ```
 *
 * @param styles styles to apply for `:focus` state
 * @param visibleOnly whether to apply styles only to the `:focus-visible` state (see above)
 * @returns style object with custom focus styels and browser focus reset
 */
var resetFocus = function resetFocus() {
  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var visibleOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, focusSelector, _objectSpread2({
    outline: 0
  }, styles)), focusVisibleSelector, _objectSpread2({
    outline: 0
  }, styles)), focusVisibleInvertSelector, _objectSpread2({}, visibleOnly ? visibleOnly === true ? invert(styles) : visibleOnly : {})), '::-moz-focus-inner', {
    border: 0,
    outline: 0
  });
};
var noFocus = /*#__PURE__*/resetFocus();

export { noFocus as n, resetFocus as r };
